module.exports = __webpack_public_path__ + "static/deep-sea-blue--medium-8b373613bae7e26527c94fdf2af5f9cd.jpg";